export const episodePermissions = {
  EPISODE_VIEW: {
    enabled: [
      'episode_oo_view',
      'episode_oo_edit',
      'episode_oo_create',
      'episode_partner_view',
      'episode_partner_edit',
      'episode_partner_create',
      'episode_view_oo',
      'episode_edit_oo',
      'episode_create_oo',
      'episode_view_partner',
      'episode_edit_partner',
      'episode_create_partner',
    ],
  },
  EPISODE_CREATE: {
    enabled: ['episode_oo_create', 'episode_partner_create', 'episode_create_oo', 'episode_create_partner'],
  },
  EPISODE_EDIT: {
    enabled: ['episode_oo_edit', 'episode_partner_edit', 'episode_edit_oo', 'episode_edit_partner'],
    disabled: [
      'episode_oo_view',
      'episode_oo_delete',
      'episode_oo_create',
      'episode_partner_view',
      'episode_partner_delete',
      'episode_partner_create',
      'episode_view_oo',
      'episode_delete_oo',
      'episode_create_oo',
      'episode_view_partner',
      'episode_delete_partner',
      'episode_create_partner',
    ],
  },
  EPISODE_DELETE: {
    enabled: ['episode_oo_delete', 'episode_partner_delete', 'episode_delete_oo', 'episode_delete_partner'],
  },
};
